export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 border-b border-border pb-6">
      <div>
        <div className="text-[10px] uppercase tracking-[0.3em] text-rugby-yellow mb-2">
          RCV U14 · 2026/2027
        </div>
        <h1 className="font-head font-bold uppercase tracking-tighter text-4xl sm:text-5xl leading-none">
          {title}
        </h1>
        {subtitle && (
          <p className="text-muted-foreground mt-2 text-sm">{subtitle}</p>
        )}
      </div>
      {children && <div className="flex items-center gap-3">{children}</div>}
    </div>
  );
}
